//
//
//
//
export default {
  name: "cpt-iframe",
  props: {
    option: Object
  }
};